import s from "./about.module.scss";
import { Container } from "../../components/container";
import { Title } from "../../components/title";
import { Subtitle } from "../../components/subtitle";
import { MyButton } from "../../components/button";
import { Row, Col } from "antd";
import { gsap } from "gsap";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const About = ({ reference }) => {
  const { t } = useTranslation();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(`.${s.about}`, {
        duration: 1,
        y: 100,
        opacity: 0,
      });
    }, reference);
    return () => ctx.revert();
  }, [reference]);
  const downloadFileAtURL = () => {
    const aTag = document.createElement("a");
    aTag.href = `${window.location.origin}/resume.pdf`;
    aTag.setAttribute("download", "resume");
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };
  return (
    <div className={s.about}>
      <Container>
        <Row
          gutter={[0, { xs: 24, sm: 24 }]}
          justify={{ xs: "center", sm: "center", md: "space-between" }}
        >
          <Col xs={24} sm={24} md={9}>
            <div className={s.image}>
              <img src={"/GREENCARD 2.jpg"} alt="MyPhoto" />
            </div>
          </Col>
          <Col className={s.col2} xs={24} sm={24} md={13}>
            <div className={s.info}>
              <Title span={t("name")} size={25}>
                {t("surname")}
              </Title>
              <Subtitle
                skills={[t("animation_web"), t("animation_game")]}
                size={20}
              >
                {t("animation_Iam")}
              </Subtitle>
              <hr />
              <p className={s.text}>{t("about_description")}</p>
              <MyButton onClick={() => downloadFileAtURL()}>
                {t("about_download")}
              </MyButton>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
